import { gql } from '@apollo/client';

export const DELETE_ACCOUNT_MUTATION = gql`
  mutation DeleteAccountMutation($input: DeleteAccountInput!) {
    deleteAccount(input: $input) {
      success
      message
    }
  }
`;

export interface DeleteAccountInput {
  deviceId: string | null; // 可以为空
}

export interface DeleteAccountResponse {
  deleteAccount: {
    success: boolean;
    message: string;
  };
}

export interface DeleteAccountVariables {
  input: DeleteAccountInput;
} 